import { ThesaurusConceptReference } from '@stylehaven/components';
import { capitalize } from 'lodash-es';

export function GetThesaurusConceptReferenceLabel(
    concept: ThesaurusConceptReference,
    languageCode: string
): string | null {
    const capitalizedLang: string = capitalize(languageCode.toLowerCase());
    const thesaurusLabel: string | undefined = concept[capitalizedLang];
    const thesaurusLabelLeaf: string | undefined = thesaurusLabel?.split('>').pop()?.trim();

    if (!thesaurusLabelLeaf) {
        return null;
    }

    return thesaurusLabelLeaf;
}
